import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { WHOLESALE_ROUTES } from '../../urls'
import Page404 from '../Page404'
import Footer from './components/Footer/Footer'
import Header from './components/Header/Header'
import { WholeSaleHomeView } from './Home'
import RegistrationView from './Registration/View'
import ProductsView from './Products/View'
import ProductView from './Product/View'
import TermsView from './Terms/View'
import AccountCreatedView from './AccountCreated/View'
import BlogView from './Blog/View'
import BlogArticleView from './BlogArticle/View'

const WholeSaleRoutes: React.FC = () => {
  return (
    <div className='flex flex-col min-h-screen'>
      <Header />
      <main className='flex-1'>
        <Switch>
          <Route exact path={WHOLESALE_ROUTES.HOME}>
            <WholeSaleHomeView />
          </Route>
          <Route exact path={WHOLESALE_ROUTES.REGISTRATION}>
            <RegistrationView />
          </Route>
          <Route exact path={WHOLESALE_ROUTES.PRODUCTS}>
            <ProductsView />
          </Route>
          <Route exact path={WHOLESALE_ROUTES.PRODUCT}>
            <ProductView />
          </Route>
          <Route exact path={WHOLESALE_ROUTES.TERMS}>
            <TermsView />
          </Route>
          <Route exact path={WHOLESALE_ROUTES.APP_CREATED}>
            <AccountCreatedView />
          </Route>
          <Route exact path={WHOLESALE_ROUTES.BLOG}>
            <BlogView />
          </Route>
          <Route exact path={WHOLESALE_ROUTES.BLOG_ARTICLE}>
            <BlogArticleView />
          </Route>
          <Route path='/not-found/' component={Page404} />
        </Switch>
      </main>
      <Footer />
    </div>
  )
}

export default WholeSaleRoutes
